// 订阅管理service
import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';

// 列表接口
export const getSubscribeManagerTable: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v2/pubsub/subscribe/list',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

// 发送记录
export const getsubscribeRecordTable: (data: any) => Promise<any> = (data) => {
  const options = {
      url: '/api/v2/pubsub/subscribe/log/list',
      method: 'post',
      data: data,
  }
  return dashboardRequest(options)
};

export const getSubscribeReceiverList: (data: any) => Promise<any> = (data) => {
  const options = {
      url: '/api/v2/pubsub/subscribe/receiver/list',
      method: 'post',
      data: data,
  }
  return dashboardRequest(options)
};

export const saveSubscribeSetting: (data: any) => Promise<any> = (data) => {
  const options = {
      url: '/api/v2/pubsub/subscribe/save',
      method: 'post',
      data: data,
  }
  return dashboardRequest(options)
};

export const previewSubscribeSetting: (data: any) => Promise<any> = (data) => {
  const options = {
      url: '/api/v2/pubsub/subscribe/preview',
      method: 'post',
      data: data,
  }
  return dashboardRequest(options)
};

export const emailJumpToUnsubscribe: (data: any) => Promise<any> = (data) => {
  const options = {
      url: '/api/v2/pubsub/subscribe/unsubscribe',
      method: 'post',
      data: data,
  }
  return dashboardRequest(options)
};